/**
 * mailCrdtBridge — routes CRDT entity updates for Mail.* types into the
 * MailApp's own thread cache instead of the entity registry's space scope.
 *
 * Mail entities (Mail.Thread, Mail.Folder, Mail.Draft) are excluded from the
 * global entity store. When the CRDT layer receives an update for one of these
 * types it calls handleMailCrdtUpdate() here, which lazily imports mailAppStore
 * and broadcasts the change to all active store instances via their caches.
 */

export const MAIL_CRDT_TYPES = new Set([
  'Mail.Thread',
  'Mail.Folder',
  'Mail.Draft',
]);

export function handleMailCrdtUpdate(entity: Record<string, unknown>): void {
  // Lazy import to avoid circular dependency with mailAppStore at module init time.
  import('../apps/MailApp/store/mailAppStore').then(({ broadcastMailCrdtUpdate }) => {
    broadcastMailCrdtUpdate(entity);
  }).catch(() => {});
}

export function handleMailCrdtDelete(entityId: string): void {
  import('../apps/MailApp/store/mailAppStore').then(({ broadcastMailCrdtDelete }) => {
    broadcastMailCrdtDelete(entityId);
  }).catch(() => {});
}
